import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { LigacaoTelemarketing } from '../models/ligacao-telemarketing';

@Injectable({
  providedIn: 'root'
})
export class FilaTarefaService {

  constructor(private http: HttpClient) { }

  consultarLista(tipoFila, idFila, status, somenteAbertas, idFuncionario, pesquisa, tipoFiltro, inicio, fim, tipoOrdenacao, pag, qt, possuiProposta, pesquisaIntegradorProponente) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/ListarTarefas',
      this.montarBodyFiltros(tipoFila, idFila, status, somenteAbertas, idFuncionario, pesquisa, tipoFiltro, inicio, fim, tipoOrdenacao, pag, qt, possuiProposta, pesquisaIntegradorProponente));
  }

  // idsTarefas preenchido: a API transfere só essas tarefas e ignora os filtros.
  contarTarefasParaTransferir(filtros: any, idFuncionarioDestino: number, idsTarefas: number[] = null) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/ContarTarefasParaTransferir', this.montarBodyTransferencia(filtros, idFuncionarioDestino, idsTarefas));
  }

  transferirTarefas(filtros: any, idFuncionarioDestino: number, idsTarefas: number[] = null) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/TransferirTarefas', this.montarBodyTransferencia(filtros, idFuncionarioDestino, idsTarefas));
  }

  private montarBodyTransferencia(filtros: any, idFuncionarioDestino: number, idsTarefas: number[]) {
    const { tipoOrdenacao, pag, qt, ...body } = this.montarBodyFiltros(filtros.tipoFila, filtros.idFila, filtros.status, filtros.somenteAbertas, filtros.idFuncionario,
      filtros.pesquisa, filtros.tipoFiltro, filtros.inicio, filtros.fim, null, null, null, filtros.possuiProposta, filtros.pesquisaIntegradorProponente);

    return { ...body, idFuncionarioDestino, idsTarefas };
  }

  private montarBodyFiltros(tipoFila, idFila, status, somenteAbertas, idFuncionario, pesquisa, tipoFiltro, inicio, fim, tipoOrdenacao, pag, qt, possuiProposta, pesquisaIntegradorProponente) {
    return {
      inicio: inicio !== null && inicio !== undefined && fim !== null && fim !== undefined ? inicio : null,
      fim: inicio !== null && inicio !== undefined && fim !== null && fim !== undefined ? fim : null,
      tipoFiltro: tipoFiltro !== null && tipoFiltro !== undefined ? tipoFiltro : 0,
      tipoFila: tipoFila !== null && tipoFila !== undefined ? tipoFila : null,
      idFila: idFila !== null && idFila !== undefined ? idFila : null,
      status: status !== null && status !== undefined ? status : null,
      somenteAbertas: somenteAbertas !== null && somenteAbertas !== undefined ? somenteAbertas : false,
      idFuncionario: idFuncionario !== null && idFuncionario !== undefined ? idFuncionario : null,
      pesquisa: pesquisa !== null && pesquisa !== undefined ? pesquisa : null,
      tipoOrdenacao: tipoOrdenacao !== null && tipoOrdenacao !== undefined ? tipoOrdenacao : null,
      pag: pag !== null && pag !== undefined ? pag : null,
      qt: qt !== null && qt !== undefined ? qt : null,
      possuiProposta: possuiProposta !== null && possuiProposta !== undefined ? possuiProposta : null,
      pesquisaIntegradorProponente: pesquisaIntegradorProponente !== null && pesquisaIntegradorProponente !== undefined ? pesquisaIntegradorProponente : null
    };
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaTarefa/BuscarTarefa',
      { params: new HttpParams().set('id', id.toString()) });
  }

  definirPrioridade(id, temPrioridade) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/DefinirPrioridade', {},
      { params: new HttpParams().set('id', id.toString()).set('temPrioridade', temPrioridade) });
  }

  vincularTarefaComFuncionario(tarefa, idFuncionario) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/VincularTarefaComFuncionario', tarefa,
      { params: new HttpParams().set('idFuncionario', idFuncionario.toString()) });
  }

  vincularTarefasSemFuncionario(idFila) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/VincularTarefasSemFuncionario', {},
      { params: new HttpParams().set('idFila', idFila.toString()) });
  }

  alterarStatusTarefa(id, status, obs) {

    let parametros = new HttpParams().set('id', id).set('status', status);

    if (obs !== null && obs !== undefined){
      parametros = parametros.set('obs', obs);
    }

    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/AlterarStatusTarefa', {},
      { params: parametros });
  }

  consultarLog(idTarefa: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaTarefa/BuscarLog',
      { params: new HttpParams().set('idTarefa', idTarefa.toString()) });
  }

  consultarTarefasDoPedido(idCupom, tipo) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaTarefa/BuscarTarefasDoPedido',
      { params: new HttpParams().set('idCupom', idCupom).set('tipo', tipo) });
  }
}
